import React, { useEffect, useState } from "react";
import placeHolderImage from "./images/place-holder.png";

function IndividualMlo(mloData) {
  const loanOfficer = mloData.mloData;

  const URL = "https://onetrusthomeloans.com/contact/";

  const containsReverse = loanOfficer.Title.includes("Reverse")
    ? "https://onetrusthomeloans.com/contact/"
    : "https://onetrusthomeloans.com/contact/";

  return (
    <div className="flex flex-col justify-center p-12 px-12">
      <div className="text-center">
        {loanOfficer.Website_Headshot__c ? (
          <div
            className="w-60 h-60 rounded-full mb-4 mx-auto border-4 border-blue-primary"
            style={{
              backgroundImage: `url(${loanOfficer.Website_Headshot__c})`,
              backgroundSize: "cover",
            }}
          ></div>
        ) : (
          <div
            className="w-60 h-60 rounded-full mb-4 mx-auto border-4 border-blue-primary"
            style={{
              backgroundImage: `url(${placeHolderImage})`,
              backgroundSize: "cover",
            }}
          ></div>
        )}
        <p className="text-2xl font-bold">
          {loanOfficer.FirstName} {loanOfficer.LastName}
        </p>
        <p className="text-lg ">{loanOfficer.Phone}</p>
        <p className="text-lg ">{loanOfficer.Email}</p>
        <p className="text-lg ">{loanOfficer.Street}</p>
        <p className="text-lg ">
          {loanOfficer.City}, {loanOfficer.State} {loanOfficer.PostalCode}
        </p>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href={`${containsReverse}${loanOfficer.Account}`}
        >
          <button
            type="button"
            className="mt-4 ml-6 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-blue-primary hover:bg-blue-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary"
          >
            Visit My Site
          </button>
        </a>
      </div>
    </div>
  );
}

export default IndividualMlo;
